// A rule change scored on the last week with games in it, both ways: the
// editor's preview of a draft (LEAGUE_SETTINGS.md), and the Rules page's of a
// change up for a vote (B6). One table, so a voter reads what the commissioner
// read when they proposed it.

import type { RulesPreviewView } from '@fsp/domain';
import { Stack, Table, Text } from '../../kit/ui';

export function PreviewTable({
  preview,
  failure,
  pending,
}: {
  preview: RulesPreviewView | null;
  failure: string | null;
  pending: boolean;
}) {
  if (failure !== null) return <Text tone="bad">{failure}</Text>;
  if (preview === null) return <Text tone="secondary">{pending ? 'Scoring it…' : ''}</Text>;
  if (preview.status === 'none' || preview.rows.length === 0) {
    return <Text tone="secondary">Nothing to preview until games have been played.</Text>;
  }
  return (
    <Stack gap={2}>
      <Text tone="secondary" size="xs">
        Under these rules, {preview.label}
        {preview.status === 'live' ? ' so far' : ''}:
      </Text>
      <Table
        label="Preview"
        head={['Team', 'Now', 'Then', 'Δ']}
        numeric={[1, 2, 3]}
        rows={preview.rows.map((r) => ({
          key: r.team.id,
          strong: r.team.isMine,
          cells: [
            <span key="t">
              {r.team.name}
              {r.rankNow !== r.rankThen ? (
                <Text tone="secondary">
                  {' '}
                  {r.rankNow} → {r.rankThen}
                </Text>
              ) : null}
            </span>,
            r.current.toFixed(1),
            r.candidate.toFixed(1),
            <Text key="d" tone={r.delta > 0 ? 'good' : r.delta < 0 ? 'bad' : 'muted'} numeric>
              {r.delta > 0 ? '+' : ''}
              {r.delta.toFixed(1)}
            </Text>,
          ],
        }))}
      />
    </Stack>
  );
}
